<div class="row" [ngClass]="{ 'justify-content-center': align() === 'center' }">
  <div [ngClass]="{ 'col-lg-8 text-center': align() === 'center' }">
    <h2 class="information-card-row__title" *scText="title()"></h2>
    @if (isContentEditorActive || content()?.value) {
      <div class="information-card-row__content" *scText="content()!"></div>
    }
  </div>
</div>
<div class="card-grid" [attr.data-cards]="cards().length">
  @for (card of cards(); track card.id) {
    <wl-information-card
      [title]="card.title"
      [content]="card.content"
      [image]="card.image"
      [button]="card.button"
      [aspectRatio]="aspectRatio()"
    />
  }
</div>
@if (link(); as link) {
  <div class="information-card-row__actions">
    <a
      class="d-inline-block"
      *wlGenericLink="link"
      wlTrackLink
      [trackLinkInfo]="{
        rendering: { componentName: 'InformationCardRowComponent' },
        field: link?.value?.text || '',
        eventType: 'button-click',
        type: 'button',
      }"
    >
      <span class="me-1">{{ link.value?.text }}</span>
      <crnt-icon slot="trailing" icon="chevron-right" size="base" />
    </a>
  </div>
}
